import { RandomId } from "@swivl-mono/helpers";
import { NodeInterface } from "@swivl-mono/types";

import UserVariablesDropdown from "../../../../Components/Dropdowns/UserVariablesDropdown/UserVariablesDropdown";
import TabNodeLayoutData from "../NodeLayouts/TabNodeLayoutData";
import InspectorFooter from "../SidePanel/Inspector/components/InspectorFooter";
import InspectorNodeHeader from "../SidePanel/Inspector/components/InspectorNodeHeader";
import NodePanel from "./NodePanel";

const StoreInfo = {
  Type: "storeInfo",
  Empty: function () {
    let node = {
      id: RandomId(6),
      type: StoreInfo.Type,
      goto: "",
      locationCodeVariableId: "LocationId",
      invalidGoto: ""
    };

    return node; //
  },
  PlumbData: function (node: NodeInterface) {
    const tabs = [
      {
        id: "goto",
        source: "goto",
        target: node.goto,
        title: "Success"
      },
      {
        id: "invalidGoto",
        source: "invalidGoto",
        target: node.invalidGoto,
        title: "Invalid"
      }
    ];
    return TabNodeLayoutData({
      node: node,
      title: "Get Store Info",
      baseWidth: 170,
      tabs: tabs
    });
  },
  InspectorPanel: class InputInspectorPanel extends NodePanel {
    constructor(props: any) {
      super(props);
    }

    render() {
      return (
        <div>
          <div className="panel message_panel">
            <InspectorNodeHeader title="Get Store Info" />
            <label>Store Location Code</label>
            <UserVariablesDropdown
              onChange={this.onChange}
              skipUserId={true}
              name={"locationCodeVariableId"}
              value={this.props.node.locationCodeVariableId}
            />
          </div>
          <InspectorFooter
            deleteNode={this.deleteNode}
            node={this.props.node}
            duplicateNode={this.props.duplicateNode}
            canDuplicate={this.props.canDuplicate}
          />
        </div>
      );
    }
  }
};
export default StoreInfo;
